import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-no-data',
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.scss']
})
export class NoDataComponent {
  @Input() message = 'No data';
}
